import styled from "styled-components";
import {
  headerSize,
  panelSpacing,
  Scrollable,
} from "../../../../../../common/styles";
import colors from "../../../../../../config/colors";

export const DashboardOuterContainer = styled.div`
  margin: 0 20px;
  padding-right: 10px;
  overflow-x: clip;
  ${Scrollable}
  height:calc(100vh - 150px);
`;
export const DashboardInnerContainer = styled.div``;
export const DashboardUpperRow = styled.div`
  overflow-x: auto;
  width: 100%;
  padding-bottom: 15px;
`;
export const Boxes = styled.div`
  display: flex;
  gap: 20px;
`;
export const Box = styled.div`
  border-radius: 10px;
  border: 1px solid #dbdbdb;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  min-width: 240px;
  max-width: 275px;
  width: 100%;
`;
export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
`;
export const IconWrapper = styled.div`
  border-radius: 16px;
  background: rgba(68, 68, 155, 0.1);
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const InfoIconWrapper = styled.div`
  cursor: pointer;
`;
export const Description = styled.div`
  padding-left: 12px;
`;
export const DescriptionTitle = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 3px 0 8px;
`;
export const DescriptionValue = styled.p`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: ${(props) => (props.textSize ? props.textSize : "40px")};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
`;
export const BoxBottom = styled.div`
  border-top: 1px solid #dbdbdb;
`;
export const BottomInfo = styled.p`
  margin: 0;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding: 8px;
`;
export const DashboardBottomRow = styled.div``;
export const InfoLeft = styled.div`
  display: flex;
  align-items: flex-start;
`;
export const Statistics = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 24px;
`;
export const MatchedBox = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(100%);
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const BoxTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
export const BoxTitle = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
export const ViewMatches = styled.div`
  cursor: pointer;
  border-radius: 3px;
  background: rgba(79, 68, 155, 0.1);
  padding: 5px 8px;
  color: #4f449b;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Invited = styled.span`
  cursor: pointer;
  border-radius: 3px;
  background: rgba(57, 109, 250, 0.1);
  padding: 5px 8px;
  color: #396dfa;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Pending = styled.span`
  cursor: pointer;
  border-radius: 3px;
  background: rgba(255, 135, 37, 0.1);
  padding: 5px 8px;
  color: #ff8725;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Graph = styled.div`
  display: flex;
  justify-content: center;
  img {
    height: 270px;
    object-fit: contain;
  }
`;
export const MeetingsConducted = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(100%);
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const Dropdown = styled.div``;
export const AverageMeetings = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(100%);
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const Input = styled.div``;
export const Applicants = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(92%);
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const ActiveUsers = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(100%);
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const BoxInner = styled.div``;
export const BoxDescription = styled.p`
  color: #b3b3b3;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 6px 0 0;
`;
export const Download = styled.div`
  border-radius: 3px;
  border: 1px solid #ededed;
  padding: 5px 4px;
  height: 30px;
  width: 96px;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;
export const Invite = styled.button`
  cursor: pointer;
  border-radius: 5px;
  background: rgba(79, 68, 155, 0.1);
  padding: 10px 25px;
  color: #4f449b;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: none;
`;
export const User = styled.div`
  padding: 0 12px;
  width: 22%;
  margin-top: 25px;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 640px) {
    width: 35%;
  }
`;
export const ImageWrapper = styled.div`
  width: 95px;
  height: 95px;
  border-radius: 10px;
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
`;
export const UserTag = styled.div`
  width: 85px;
  height: 45px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  bottom: -22px;
  // left: 25px;
  border-radius: 4px;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
`;
export const MostActiveUsers = styled.div`
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
  max-width: calc(33% - 36px);
  @media (max-width: 1200px) {
    max-width: calc(50% - 36px);
  }
  @media (max-width: 640px) {
    max-width: calc(100%);
    padding-bottom: 40px;
    min-height: fit-content;
  }
  width: 100%;
  padding: 12px;
  min-height: 320px;
  max-height: 320px;
`;
export const Number = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const Name = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Table = styled.div``;

export const Users = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
`;

export const MatchChartOuter = styled.div`
  display: flex;
  flex-direction: column;
  svg {
    * {
      outline: none;
    }
    outline: none;
  }
`;

export const CustomLegendContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 12px;
`;

export const CustomLegendInner = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => (props.index < props.data - 1 ? "20px" : "0")};
  font-family: "Nunito Sans";
  font-weight: "500";
  font-size: 14px;
`;

export const ColorDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
`;
export const NoMentorFound = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: rgb(48, 47, 47);
`;

export const CustomLegendValue = styled.span`
  color: #70708c;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const MeetingsConductedChartOuter = styled.div`
  height: 250px;
  width: 100%;
  margin-top: ${(props) => (props.marginTop ? "30px" : "53px")};
`;

export const CustomToolTipContent = styled.div`
  padding: 6px 8px;
  max-width: 114px;
  width: 100%;
  min-height: 84px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dbdbdb;
`;

export const CustomToolTipText = styled.p`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 0;
`;

export const CustomToolTipBoldText = styled.span`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const FollowLink = styled.div`
  cursor: pointer;
`;

export const TableContainer = styled.div`
  height: ${(props) => (props.isDashboard ? "" : "750px")};
  overflow: auto;
  .text-wrap {
    word-break: break-all;
    max-width: 150px;
    @media (max-width: 768px) {
      word-break: normal;
      max-width: 100%;
    }
  }
`;

export const TableContainer2 = styled.div`
  height: ${(props) => (props.isDashboard ? "235px" : "750px")};
  overflow: auto;
  border-bottom: none;
  .text-wrap {
    word-break: break-all;
    max-width: 150px;
    @media (max-width: 768px) {
      word-break: normal;
      max-width: 100%;
    }
  }
`;

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: ${panelSpacing}px;
`;

export const AvatarInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  p {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }
`;

export const StatisticsLoader = styled.div`
  background-color: ${colors.background};
  border-radius: ${panelSpacing}px;
  box-sizing: border-box;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 300;
`;
export const ChartsLoader = styled.div`
  background-color: ${colors.background};
  border-radius: ${panelSpacing}px;
  box-sizing: border-box;
  height: 290px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 300;
`;

export const FormattedDate = styled.span`
  margin-right: 10px;
`;

export const IconContainer = styled.div`
  cursor: pointer;
  display: inline;
  vertical-align: middle;
`;

export const ViewMoreContainer = styled.div`
  color: #386cfa;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  padding: 12px 0;
  border-top: 1px solid #dbdbdb;
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  border-bottom: 1px solid #dbdbdb;
  @media (max-width: 768px) {
    padding: 8px 0;
  }
`;

export const ViewMoreText = styled.span`
  cursor: pointer;
`;

export const ModalWrapper = styled.div`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
  background: #fff;
  box-shadow: 0px 4px 50px 0px rgba(151, 140, 140, 0.2);
  max-width: 340px;
  position: absolute;
  right: 0;
  top: 45px;
  @media (max-width: 768px) {
    max-width: 270px;
  }
`;

export const InputField = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  border: none;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  &:focus {
    outline: none;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const InputWrapper = styled.div`
  display: flex;
  border-radius: 5px;
  border: 1px solid #ededed;
  width: 300px;
  height: 14px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  select {
    border: none;
    color: #333232;
    font-family: "Nunito Sans";
    &:focus {
      outline: none;
    }
  }
  @media (max-width: 768px) {
    max-width: 245px;
  }
`;

export const FileLabel = styled.label`
  color: #386cfa;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`;

export const ModalHeadText = styled.h3`
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2ebf3;
`;

export const Button = styled.button`
  width: 80px;
  height: 34px;
  padding: 5px 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: ${({ primary }) => (primary ? "#45459B" : "#FFFFFF")};
  color: ${({ primary }) => (primary ? "#FFFFFF" : "#333232")};
  border: ${({ primary }) =>
    primary ? "1px solid transparent" : "1px solid #EDEDED"};
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const Actions = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
  padding-top: 24px;
  gap: 10px;
  border-top: 1px solid #e2ebf3;
`;

export const TooltipContainer = styled.div`
  display: inline-block;
  position: absolute;
  cursor: pointer;
  border-radius: 10px;
  background: #494949;
  padding: 10px;
`;

export const TooltipText = styled.span`
  color: #fff;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.07px;
`;

export const FileInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border-radius: 5px;
  border: 1px solid #ededed;
  width: 300px;
  height: 14px;
  padding: 10px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    max-width: 245px;
  }
`;
export const FileContainer = styled.div`
  display: flex;
  gap: 6px;
`;
export const FileName = styled.span`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FileHeading = styled.h3`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding-top: 10px;
  border-top: 1px solid #e2ebf3;
`;

export const NullStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 270px;
`;
export const NullStateText = styled.p`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
